<template>
  <div class="editor-container" id="lovers">
    <div class="fixed">
      <EditorMenu />
      <GlassPreview>
        <div
          v-for="attributeValue in attributes.loverType.attribute_values"
          :data-title="attributeValue.name"
          :id="`lovers-${attributeValue.id}`"
          class="lovers-variation"
          :class="{
            decorative:
              attributeValue.preferences.elements.includes('decorative'),
            pin: attributeValue.preferences.elements.includes('pin'),
            heart: attributeValue.preferences.elements.includes('heart'),
            hearts: attributeValue.preferences.elements.includes('hearts'),
            tripleHeart:
              attributeValue.preferences.elements.includes('tripleHeart'),
            drawnHeart:
              attributeValue.preferences.elements.includes('drawnHeart'),
            ring: attributeValue.preferences.elements.includes('ring'),
            hidden:
              product.attribute_values.loverType &&
              product.attribute_values.loverType.id !== attributeValue.id,
          }"
        >
          <p
            class="names"
            v-if="attributeValue.preferences.elements.includes('names')"
          >
            {{ names }}
          </p>
          <p
            class="date"
            v-if="attributeValue.preferences.elements.includes('date')"
          >
            {{ date }}
          </p>
          <p
            class="place"
            v-if="attributeValue.preferences.elements.includes('place')"
          >
            {{ place }}
          </p>
          <span
            v-if="attributeValue.preferences.elements.includes('tripleHeart')"
            class="heart"
          ></span>
        </div>
      </GlassPreview>
    </div>
    <div class="product-fields">
      <!-- Sold -->
      <SoldCapacity v-if="soldCapacity"/>
      <!-- Editor -->
      <div class="form-fields">
        <ImageHandler />
        <LoverFields />
        <GlobalAttributes />
        <!-- <ProductServices :product="product" /> -->
        <AddToCart />
      </div>
      <Loader />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { url } from "../../../../helpers";
import EditorMenu from "./EditorMenu.vue";
import AddToCart from "./AddToCart";
import useProduct from "../useProduct";
import LoverFields from "./lover/LoverFields";
import ImageHandler from "./ImageHandler";
import ProductServices from "./../../../packages/views/product-service/Services";
import Loader from "../../../packages/views/loader/Loader";
import GlobalAttributes from "./attributes/GlobalAttributes";
import useLover from "../useLover";
import GlassPreview from "./glass-preview/Base";
import SoldCapacity from "./SoldCapacity.vue";

export default {
  components: {
    ProductServices,
    Loader,
    ImageHandler,
    LoverFields,
    AddToCart,
    GlobalAttributes,
    GlassPreview,
    EditorMenu,
    SoldCapacity,
  },
  computed: {
    ...mapGetters({
      product: "product/getProduct",
      attributes: "product/getAttributes",
      soldCapacity: 'product/getSoldCapacity'
    }),
  },
  setup() {
    const { names, date, place, hasElement } = useLover();
    const { imageUrl } = useProduct();

    return {
      hasElement,
      names,
      date,
      place,
      imageUrl,
      url,
    };
  },
};
</script>
